import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQueryParams(): URLSearchParams {
	const { search } = useLocation();
	return useMemo<URLSearchParams>(() => new URLSearchParams(search), [search]);
}
